import React from 'react';
import { Col, Layout, Row } from 'antd';
import NumberCard from './NumberCard';
import CountryCard from './countryCard';
import DonutCard from './donutCard';
import { useTranslation } from 'react-i18next';
const { Content } = Layout;

const topColResponsiveProps = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 6,
  style: { marginBottom: 24 },
};

function Dashboard(props) {
  const { t } = useTranslation();
  return (
    <Content style={{ margin: '24px 24px 0' }}>

      <Row gutter={24} type="flex">
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.total_objects')} urlPath="object-count" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.unavailable_objects')} urlPath="unavailable-objects" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_with_label')} urlPath="curatorial-label" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_loaned')} urlPath="insurance-count" />
        </Col>
      </Row>

      <Row gutter={24} type="flex">
        <Col span={6}>
          <CountryCard />
        </Col>
        <Col span={18}>
          <DonutCard />
        </Col>
      </Row>

      <Row gutter={24} type="flex" style={{ marginTop: '1em' }}>
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_with_photo')} urlPath="objects-with-photos" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_with_condition')} urlPath="condition-object-count" />
        </Col>

        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_with_curatorial')} urlPath="curatorial-object-count" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_with_technical')} urlPath="technical-object-count" />
        </Col>

        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_in_treatment')} urlPath="treatment-object-count" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_moved')} urlPath="movement-object-count" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title={t('dashboard.objects_in_bad_condition')} urlPath="objects-in-bad-condition" />
        </Col>
      </Row>
    </Content>
  );
}

export default Dashboard;